import axios from "axios";
import AppConstant from "../assets/js/AppConstant";

export const SubmitAccountingReview = async ({ ticketId }) => {
  return await axios.patch(
    AppConstant.MAIN_URL +
      `/marketing-claim-api/v1/ticket/${ticketId}/accounting-review`
  );
};
